import { useInsights } from '@/hooks/use-insights';
import { Filters } from '@/isomorphic/components/wp-blocks/insights/components/filters';

export const InsightsNav = () => {
    const { sortedTerms, goTo, basePath, currentFilters } = useInsights();

    return <Filters currentFilters={currentFilters} sortedTerms={sortedTerms} basePath={basePath} goTo={goTo} navBar />;
};
